import {
  Button,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  notification,
  Row,
  Select,
  Table,
  Tag,
  Tooltip,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import MasterDataAPI from "../../restAPI/MasterDataAPI";
import { CheckOutlined, DeleteOutlined } from "@ant-design/icons";
import CommitteeAPI from "../../restAPI/CommitteeAPI";
import {commonInformationCapture, selectedCommitteeIdCapture,} from "../../redux/slices/meetingSlice";
import CommonSkeletonLoader from "../CommonSkeleton";

const CommitteeInfo = forwardRef((props, ref) => {
  const buttonTypesRef = useRef({});
  const hasAutoPopulatedRef = useRef(false);
  const { companyId, token, userCompany, role } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  const { committee } = useSelector((state) => state.meeting);
  const [committeeType, setCommitteeType] = useState(null);
  const [committeeName, setCommitteeName] = useState(null);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [memberListByBranch, setMemberListByBranch] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [committeeNameList, setCommitteeNameList] = useState([]);
  const [fullCommitteeNameList, setFullCommitteeNameList] = useState([]);
  const [committeeData, setCommitteeData] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [companyBranchList, setCompanyBranchList] = useState([]);
  const [companyUsersList, setCompanyUsersList] = useState([]);
  const [fullDataMemberListByBranch, setFullDataMemberListByBranch] = useState(
    []
  );
  const [currentCompanyInfo, setCurrentCompanyInfo] = useState({});
  const [committeeTabLoading, setCommitteeTabLoading] = useState(false);
  const [form] = Form.useForm();

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement,
    });
  };

  useEffect(() => {
    const companyInfo = userCompany.companyData.find(
      (company) => company.companyId === companyId
    );    
    setCurrentCompanyInfo(companyInfo);
  }, [companyId]);

  useImperativeHandle(ref, () => ({
    setLoading: (loading) => setCommitteeTabLoading(loading),
    validateAndRetrieveData: async () => {
      try {
        const values = await form.validateFields();
        return values;
      } catch (error) {
        throw error;
      }
    },
  }));


 

  const getuserList = async () => {
    try {
      const res = await MasterDataAPI.getUsersDataByCompanyId(companyId, token);
      if (res) {
        const newMemberDataList = res?.data
          ? res?.data
              .filter((user) => user.status)
              .map((singleUser) => {
                return {
                  id: singleUser.id,
                  name: singleUser.name,
                  designation: singleUser.designation,
                  email: singleUser.email,
                  mobileNumber: singleUser.personalNumber,
                  companyAddress: singleUser.address,
                  branchId: singleUser?.branch?.id,
                  roleList: singleUser?.roles[0]?.id,
                };
              })
          : [];

        setCompanyUsersList(newMemberDataList);
      }
    } catch (error) {
      console.log("error in get user list ", error);
    }
  };

  const getCommitteeTypes = async () => {
    if (role.some((r) => r.restricted === true)) {
      // await MasterDataAPI.getCommitteeDataByCompanyId(companyId, token)
      await CommitteeAPI.getCommitteeTypeByUserDetailsId(currentCompanyInfo.userDetailsId, companyId, token)
        .then((res) => {
          const activeCommittee = res?.data
            ? res?.data.data
                .filter((committee) => committee.status)
                .map((committee) => {
                  return { label: committee.name, value: committee.id };
                })
            : [];
          setCommitteeData(activeCommittee);
        })
        .catch((err) => {
          console.log("Error :", err.message);
        });
    }
  };

  const getCommitteeListByCommitteeTypeId = async () => {
    try {
      if(!committeeType) return;
      const response = await CommitteeAPI.getCommitteedataByTypeAndUserDetailsId(committeeType, companyId, token);
      const activeCommitteeNamesList = response.data
          ? response.data.data
              .filter((committee) => committee.status)
              .map((committee) => {
                return { label: committee.name, value: committee.id };
              })
          : [];
      
        setFullCommitteeNameList(activeCommitteeNamesList);
    } catch (error) {
      console.log('error in getCommitteeListByCommitteeTypeId :', error);
    }
  }

  const filterSingleBranchDetails = (branchId = null) => {
    if (!companyBranchList || !branchList) return {};

    const singleBranch = companyBranchList.find(
      (branch) => branch.id == branchId
    );

    const singleBranchDetails = singleBranch
      ? { id: singleBranch.id, name: singleBranch.name }
      : {};

    return singleBranchDetails?.name;
  };

  const getCommitteeDataByCommitteeId = async () => {    
    try {
      const res = await MasterDataAPI.getCommitteeDataByCommitteeId(
        committeeName,
        companyId,
        token
      );

      filterSingleBranchDetails();

      if (res) {
        const { secretaryId, assistantSecretaryId } = res.data;
        const equalUsers = companyUsersList.filter((user) =>
          res.data?.members.includes(user.id)
        );

        const transformUsers = equalUsers.map((user) => ({
          userDetailsId: user.id,
          id: user.id,
          name: user.name,
          branch: filterSingleBranchDetails(user.branchId),
          // branch: user.branchId ? user.branchId.name : '',
          designation: user.designation || "",
          response: "optional",
          attendance: "optional",
          isDeletable: !(
            user.id === secretaryId || user.id === assistantSecretaryId
          ),          
        }));

       

        const transformUsersForProps = equalUsers.map((user) => ({
          userDetailsId: user.id,
          // committeeId: committeeName,
          name: user.name,
          branch: user.branchId ? user.branchId.name : "",
          designation: user.designation || "",
          attendance: "optional",
        }));

        if (props.actionState === "add") {
          const meetingCommonInfo = {
            secretaryId: res?.data?.secretaryId || null,
            assistantSecretaryId: res?.data?.assistantSecretaryId || null,
          };

          dispatch(commonInformationCapture(meetingCommonInfo));
        }
        setSelectedMembers(transformUsers);
        props.setCommitteeMembersList(transformUsersForProps);
      }
    } catch (error) {
      console.log("error in getCommitteeDataByCommitteeId : ", error);
    }
  };

  const getBranchList = async () => {
    if (role.some((r) => r.restricted === true)) {
      await MasterDataAPI.getBranchDataByCompanyId(companyId, token)
        .then((res) => {
          if (res) {
            const activeBranches = res?.data
              ? res?.data
                  .filter((branch) => branch.status)
                  .map((singleBranch) => {
                    return { label: singleBranch.name, value: singleBranch.id };
                  })
              : [];

            setBranchList(activeBranches);
            setCompanyBranchList(res.data);
          }
        })
        .catch((err) => {
          setBranchList([]);
          setCompanyBranchList([]);
          console.log("Error :", err.message);
        });
    }
  };

  const getUserListByBranchId = async (branchId) => {    
    try {
      
      const res = await MasterDataAPI.getUserListByBranchId(
        branchId,
        companyId,
        token
      );

      if (res) {
        const tempUserList = res.data
          .filter((user) => user.status)
          .map((singleUser) => {
            return { label: singleUser.name, value: singleUser.id };
          });

          const filteredUserList = tempUserList.filter(
            (user) => !selectedMembers.some((member) => member.id === user.value)
          );

          console.log("temp user list :", tempUserList);
          console.log("Selected members :", selectedMembers);
          console.log("Filtered user list :", filteredUserList);

        setMemberListByBranch(filteredUserList);
        setFullDataMemberListByBranch(res.data);
      }
    } catch (error) {
      console.log("Error in getUserListByBranchId :", error);
    }
  };

  
  const showAllCompanyUsers = () => {
    const filteredUserList = companyUsersList
      .filter((user) => !selectedMembers.some((member) => member.id === user.id))
      .map((user) => ({ label: user.name, value: user.id }));
    setMemberListByBranch(filteredUserList);
    setFullDataMemberListByBranch(companyUsersList);
  };


 

  const handleMakeMandatery = (record, e) => {    
    if (!buttonTypesRef.current) {
      buttonTypesRef.current = {};
    }
    const recordKey = record.key;
    const newType =
      record.attendance === "optional" ||
      record.attendance === undefined ||
      record.attendance === null
        ? "primary"
        : "default";
    buttonTypesRef.current[record.key] = newType;

    record.attendance =
      record.attendance === "optional" ||
      record.attendance === undefined ||
      record.attendance === null
        ? "mandatory"
        : "optional";    

  
    const { participant } = committee || {};
    const members = participant?.members || [];  
    const selectedMember = Array.isArray(members) ? members.filter(member => member.userDetailsId === recordKey) : [];        
    const updatedMembers = selectedMembers.map((member) => {
      if (member.id === recordKey) {        
        return { 
          ...member,
          attendance: record.attendance, 
          rsvp: record.attendance === "mandatory" ? 'Yes' : selectedMember?.[0]?.rsvp || "default"     
        };
      }
      return member;
    });

    setSelectedMembers(updatedMembers);
    props.setCommitteeMembersList(updatedMembers);
  };

  const handleRemoveMember = (record) => {
    const filteredArray = selectedMembers.filter(
      (item) => item.id !== record.id
    );
    const propsFilteredArray = props.committeeMembersList.filter(
      (item) => item.userDetailsId !== record.id
    );
    setSelectedMembers(filteredArray);
    // check if the member exists in the current selected branch.
    const selectedMemberDetails = fullDataMemberListByBranch.find(
      (member) => member.id === record.id
    );
    if (selectedMemberDetails) {            
        const item = {
          label: selectedMemberDetails.name,
          value: selectedMemberDetails.id,
        };
        setMemberListByBranch((prevItems) =>
          [...prevItems, item].sort((a, b) => a.value - b.value)
        );      
    }
    props.setCommitteeMembersList(propsFilteredArray);
  };

  const handleAddClick = (e) => {
    // Validation for member selection (branch is now optional)
    const validateField = (fieldName, errorMessage) => {
      form.setFields([{ name: fieldName, errors: [errorMessage] }]);
    };

    if (!selectedMemberId)
      validateField("memberName", "Please select a member.");

    const selectedMemberDetails = fullDataMemberListByBranch.find(
      (member) => member.id === selectedMemberId
    );

    if (selectedMemberDetails) {
      const selectedBranchDetails = branchList?.find(
        (branch) => branch.value === selectedMemberDetails.branchId
      );

      const isMemberAlreadyAdded = (membersArray) =>
        membersArray.some((member) => member.id === selectedMemberDetails.id);

      // Check if the member is already in selectedMembers or props.committeeMembersList
      if (
        isMemberAlreadyAdded(selectedMembers) ||
        isMemberAlreadyAdded(props.committeeMembersList)
      ) {
        openNotificationWithIcon(
          "error",
          "Duplicate member",
          "Member already exists in the list.",
          "bottomLeft"
        );
        return; // Exit early if duplicate
      }

      const newMember = {
        userDetailsId: selectedMemberDetails.id,
        id: selectedMemberDetails.id,
        name: selectedMemberDetails.name,
        branch: selectedBranchDetails?.label || "",
        designation: selectedMemberDetails.designation || "",
        attendance: "optional",
        isDeletable: true,
        rsvp: "default",
        hasResponded: false,
      };

      // Update the selectedMembers state
      setSelectedMembers((prev) => [...prev, newMember]);

      // Update the committeeMembersList in the parent component
      props.setCommitteeMembersList((prev) => [
        ...prev,
        {
          ...newMember,
          attendance: "optional",
        },
      ]);
      let tempMembersList = memberListByBranch.filter(
        (single) => single.value !== selectedMemberId
      );
      setMemberListByBranch(tempMembersList);
      form.resetFields(["memberName"]);
      setSelectedMemberId(null);
      openNotificationWithIcon(
        "success",
        "Member added",
        "Member added successfully.",
        "bottomLeft"
      );
    }
  };

  

  // this effect is for setup the initial committee members to the state---
  useEffect(() => {
    if (["add", "edit"].includes(props.actionState) && (committee === null || !committee)) return;

    const { participant } = committee || {};
    const { secretaryId, assistantSecretaryId } = participant;
    const fromValues = props.actionState === 'view' ? {
        committeeType: participant?.committeeTypeName || '',
        committeeName: participant?.committeeName || '',
      } : {
        committeeType: participant?.committeeType || '',
        committeeName: participant?.committeeId || '',
      };

    form.setFieldsValue(fromValues);

    setCommitteeType(participant?.committeeType || null);
    setCommitteeName(participant?.committeeId || null);

    const members = participant?.members || [];           
    const mappedMembers = members.map((member) => ({
      id: member.userDetailsId,
      key: member.userDetailsId,
      userDetailsId: member.userDetailsId,
      name: member.name || "",
      branch: member.branch || "",
      designation: member.designation || "",
      attendance: member.attendance || "optional",
      isDeletable: !(
        member.userDetailsId === secretaryId ||
        member.userDetailsId === assistantSecretaryId
      ),
      rsvp: member.rsvp,
      hasResponded: member.hasResponded || false,
    }));

    setSelectedMembers(mappedMembers);
    props.setCommitteeMembersList(mappedMembers);
  }, [props.isPrevClickedToCommittee, committee]);

  useEffect(() => {
    getuserList();
    getCommitteeTypes();
    getBranchList();
  }, []);

  useEffect(() => {
    if (committeeType && role.some((r) => r.restricted === true)) {
      getCommitteeListByCommitteeTypeId();
    }

    if (committeeType && !props.isPrevClickedToCommittee && !committee) {
      form.setFieldsValue({ committeeName: null });
      setCommitteeNameList([]);
      setFullCommitteeNameList([]);
    }
  }, [committeeType]);

  useEffect(() => {    
    if (committeeName) {
      dispatch(selectedCommitteeIdCapture(committeeName));
      // Reset the ref when committee changes
      hasAutoPopulatedRef.current = false;
    }

    if (committeeName && !props.isPrevClickedToCommittee && !committee) {
      getCommitteeDataByCommitteeId();
    }
  }, [committeeName]);

  // Show all company users when committee is selected (no branch filter by default)
  useEffect(() => {
    if (
      (props.actionState === "add" || props.actionState === "edit") && 
      committeeName && 
      companyUsersList.length > 0 &&
      selectedMembers.length > 0 &&
      !hasAutoPopulatedRef.current
    ) {      
      showAllCompanyUsers();
      hasAutoPopulatedRef.current = true;
    }
  }, [committeeName, companyUsersList, props.actionState, selectedMembers]);

  
  useEffect(() => {
    if (committeeName && companyUsersList.length > 0 && hasAutoPopulatedRef.current) {
      if (selectedBranchId) {        
        getUserListByBranchId(selectedBranchId);
      } else {        
        showAllCompanyUsers();
      }
    }
  }, [selectedMembers.length]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <div style={{ wordBreak: "break-word" }}>{text}</div>,
    },
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      // render: (text) => <div style={{ wordBreak: 'break-word' }}>{text}</div>
    },
    {
      title: "Response",
      dataIndex: "response",
      key: "response",
      align: "center",
      fixed: "right",
      width: "130px",
      render: (_, record) =>
        record.rsvp?.toLowerCase() === "yes" ? (
          <>
            <Tag color="green" style={{ width: 90, textAlign: "center" }}>
              Yes
            </Tag>{" "}
            <br />
          </>
        ) : record.rsvp?.toLowerCase() === "no" ? (
          <Tag color="blue" style={{ width: 90, textAlign: "center" }}>
            No
          </Tag>
        ) : record.rsvp?.toLowerCase() === "maybe" ? (
          <Tag color="gold" style={{ width: 90, textAlign: "center" }}>
            May-Be
          </Tag>
        ) : (
          <Tag color="red" style={{ width: 90, textAlign: "center" }}>
            RSVP
          </Tag>
        ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      width: "120px",
      fixed: "right",
      render: (_, record) => (
        <Flex gap="small" justify="center" align="center" vertical>
          <Flex gap="middle" wrap="wrap">
            <Tooltip
              title={
                record.attendance === "optional"
                  ? "Make Mandatory"
                  : "Make Optional"
              }
            >
              <Button
                icon={<CheckOutlined />}
                size="small"
                onClick={(e) => handleMakeMandatery(record, e)}
                disabled={props.actionState === "view" || record.hasResponded}
                type={
                  buttonTypesRef.current[record.key] ||
                  (record.attendance === "optional" ||
                  record.attendance === undefined ||
                  record.attendance === null
                    ? "default"
                    : "primary")
                }
              />
            </Tooltip>
            {/* <Button type="primary" icon={<EditOutlined />} size='small' /> */}
            <Button
              danger
              type="primary"
              icon={<DeleteOutlined />}
              size="small"
              onClick={() => handleRemoveMember(record)}
              disabled={
                record.isDeletable === false || props.actionState === "view"
              }
            />
          </Flex>
        </Flex>
      ),
    },
  ];

  return (
    <Form layout="vertical" form={form}>
      {contextHolder}
      {committeeTabLoading ? (
        <>
          <CommonSkeletonLoader />
        </>
      ) : (
        <>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label="Committee Type"
                name="committeeType"
                rules={[
                  {
                    required: true,
                    message: "Please select the committee type.",
                  },
                ]}
              >
                {
                  props.actionState === "view" ? (<>
                    <Input
                      value={committee?.participant?.committeeTypeName || ""}
                      disabled
                    />
                  </>): (<>
                    <Select
                      options={committeeData}
                      placeholder="Select committee type"
                      onChange={(value) => setCommitteeType(value)}
                      disabled={
                        props.actionState === "edit" || props.actionState === "view"
                      }
                    />
                  </>)
                }
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Committee"
                name="committeeName"
                rules={[
                  { required: true, message: "Please select the committee." },
                ]}
              >
                {
                  props.actionState === "view" ? (<>
                    {/* <span style={{marginLeft:'12px'}}>{committee?.participant?.committeeName}</span> */}
                    <Input
                      value={committee?.participant?.committeeName || ""}
                      disabled
                    />
                  </>): (<>
                    <Select
                      options={fullCommitteeNameList}
                      placeholder="Select committee"
                      onChange={(value) => {
                        setCommitteeName(value);
                        form.setFieldValue("branchName", "");
                        setSelectedBranchId(null);
                        setSelectedMemberId(null);
                        setMemberListByBranch([]);
                        setSelectedMembers([]);
                        props.setCommitteeMembersList([]);
                      }}
                      value={committeeName}
                      disabled={
                        (!committeeType && !committeeName) ||
                        props.actionState === "edit" ||
                        props.actionState === "view"
                      }
                    />
                  </>)
                }
              </Form.Item>
            </Col>
            <Divider>Add Other Members</Divider>
            <Col span={8}>
              <Form.Item label="Branch" name="branchName">
                <Select
                  options={branchList}
                  placeholder="Filter members by branch"
                  allowClear={true}
                  onChange={(value) => {                  
                    setSelectedBranchId(value);
                    form.setFields([
                      {
                        name: "branchName",
                        errors: [],
                      },
                    ]);
                    setSelectedMemberId(null);
                    form.setFieldValue("memberName", null);
                    if (value) {
                      getUserListByBranchId(value);
                    } else {                      
                      showAllCompanyUsers();
                    }
                  }}
                  disabled={props.actionState === "view" || !committeeName}
                />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label="Member Name" name="memberName">
                <Flex justify="space-between" align="center" gap={24}>
                  <Select
                    showSearch
                    options={memberListByBranch}
                    allowClear={true}
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }                    
                    onChange={(value) => {
                      setSelectedMemberId(value);
                      form.setFields([
                        {
                          name: "memberName",
                          errors: [],
                        },
                      ]);
                    }}
                    value={selectedMemberId}
                    disabled={props.actionState === "view" || !committeeName}
                  />
                  <Button
                    onClick={(e) => handleAddClick(e)}
                    disabled={props.actionState === "view" || !committeeName}
                  >
                    {" "}
                    Add{" "}
                  </Button>
                </Flex>
              </Form.Item>
            </Col>
            <div style={{ width: "100%" }}>
              <Table
                dataSource={selectedMembers.map((item, index) => ({
                  ...item,
                  key: item.key || item.id || index,
                }))}
                columns={columns}
                title={() => "Selected Members"}
                expandable={{
                  expandedRowRender: () => null,
                  rowExpandable: () => false,
                }}
                rowKey="key"
              />
            </div>
          </Row>
        </>
      )}
    </Form>
  );
});

export default CommitteeInfo;
